module.exports = __webpack_public_path__ + "static/media/bg-fonze-poster.ce56f954.jpg";